import React, { useCallback, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdOutlineClose, MdOutlineCheck, MdImageAspectRatio, MdImage, MdCancel, MdPlusOne, MdHdrPlus, MdAdd, MdEdit, MdSave } from "react-icons/md";
import { Input, Button, Select, Textarea } from "react-daisyui";
import SearchableDropdown from "../common/SearchableDropdown/SearchableDropdown";
// import { CityStore, CityStoreContext } from "./store/CityStore";
// import { AdminUseStore, useAdminUsedStore, AdminUserStoreContext } from "./store/AdminUsersStore";
import { ProductCatalogStore, useProductCatalogStore, ProductCatalogStoreContext } from "./Store/ProductCatalogStore";
import { observer } from "mobx-react";
import { useAuthStore } from "../Auth/store/Auth";
import { useState } from "react";


const AddCategoryName = observer(() => {

    return (
        <ProductCatalogStoreContext.Provider
            value={
                new ProductCatalogStore({
                    loadeditcitybol: false,
                    addProductCataloglist: true,
                })
            }
        >
            <Screen />
        </ProductCatalogStoreContext.Provider>
    );
});
export default AddCategoryName;

const Screen = observer(() => {
    const { loaderdisgnCategory, CategoryName, design_id, saved, setdesign_id, addCategegorisDesgin, setCategoryName } = useProductCatalogStore();
    const { adminAuthApproved } = useAuthStore();
    const { name, id } = useParams();
    const navigate = useNavigate()
    const [Key, setkey] = useState("none");

    const handleSubmit = (e) => {
        e.preventDefault();
        // addDesignId(type, categorid);
        addCategegorisDesgin(Key, id);
    };


    useEffect(() => {
        if (saved) {
            navigate(`/desgincategory/${id}`);
        }
    }, [saved]);




    return (
        <>
            <div className="flex justify-between mt-[51px] ">
                <div className=" mb-4">
                    <p className=" text-2xl font-semibold">Admin Add Design Categories </p>
                    <p className=" opacity-80 text-sm">Home / Design Categories  / Add Design Categories  </p>
                </div>
                <div>

                    <Link
                        onClick={() => navigate(-1)}
                        className="btn btn-sm bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                    >
                        Back
                    </Link>
                </div>
            </div>
            <div className="card bg-base-100 shadow-md p-6 mt-8">
                <form onSubmit={handleSubmit}>
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 md:gap-8 gap-4">
                        <div>
                            <label
                                htmlFor="name"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Full name
                            </label>
                            <Input
                                name="name"
                                placeholder="name"
                                value={CategoryName}
                                onChange={(e) => { setCategoryName(e.target.value); }}
                                id="name"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />


                        </div>

                        <div>
                            <label
                                htmlFor="name"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Design Id<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            {Key == "none" &&
                                <div className=" flex justify-center items-center gap-3">

                                    <button
                                        onClick={() => setkey("single")}
                                        className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                        <MdAdd className="mr-1" />
                                        Single Design Id
                                    </button>
                                    <button
                                        onClick={() => setkey("multi")}
                                        className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                        <MdAdd className="mr-1" />
                                        Muliple Design Id
                                    </button>
                                </div>
                            }

                            {Key == "single" &&
                                <>
                                    <div className="space-y-2">
                                        <Input
                                            name="Design id"
                                            value={design_id}
                                            onChange={(e) => setdesign_id(e.target.value, "single")}
                                            required
                                            placeholder="Design id"
                                            id="Design id"
                                            type="text"
                                            autoComplete="off"
                                            className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                                        />
                                    </div>
                                    <div className=" flex space-x-1 items-center justify-end mt-3">
                                        <span className="underline cursor-pointer  " onClick={() => setkey("none")}  > Cancel</span>
                                    </div>
                                </>



                            }
                            {Key == "multi" &&
                                <>
                                    {/* // <form onSubmit={(e) => handleSubmit(e, "multi", category_id)}> */}
                                    <div className="space-y-2">
                                        <Textarea
                                            name="Design id"
                                            value={design_id}
                                            onChange={(e) => setdesign_id(e.target.value, "multi")}
                                            required
                                            placeholder='Please Paste Array of String i.e ["designId1" , "designId2" ,  "designId3" ]'
                                            id="Design id"
                                            type="text"
                                            autoComplete="off"
                                            className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                                        />


                                    </div>
                                    <div className=" flex space-x-1 items-center justify-end mt-3">
                                        <span className="underline cursor-pointer  " onClick={() => setkey("none")}  > Cancel</span>
                                    </div>
                                </>


                                // </form>

                            }

                        </div>
                    </div>


                    <div className="lg:mt-3 mt-4 flex items-center md:justify-end justify-between">
                        <Link
                            onClick={() => navigate(-1)}
                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                        >
                            <MdOutlineClose className="mr-1" />
                            Cancel
                        </Link>
                        {!loaderdisgnCategory ?
                            <button className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                <MdOutlineCheck className="mr-1" />
                                Add Design Category
                            </button>
                            :
                            <button
                                className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                type="button"
                            //  onClick={()=> changeStep("4")}
                            >
                                <svg
                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                                Loading..
                            </button>
                        }

                    </div>
                </form>
            </div>
        </>
    );
});

